import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../../config/config";
import { postApiCall } from "../../services/apiHelper";
import { RootState } from "../store";

export interface requestForPropertyImages {
  investmentIds: string[];
}

interface InitialState {
  ImagesOfProperty: ImagesOfProperty[];
  error: string;
  loading: boolean;
  cacheKey: string | undefined;
}
const initialState: InitialState = {
  ImagesOfProperty: [],
  error: "",
  loading: false,
  cacheKey: undefined,
};
interface ImagesOfProperty {
  original: string;
  thumbnail: string;
}

export const propertyImages = createAsyncThunk<
  ImagesOfProperty[],
  requestForPropertyImages,
  { state: RootState }
>(
  "propertyImages",
  async (requestForPropertyImages: requestForPropertyImages, { getState }) => {
    if (!requestForPropertyImages?.investmentIds?.length) return [];
    
    const state = getState().propertyImages;
    if (state.ImagesOfProperty.length > 0 && state.cacheKey === "propertyImagesCache") {
      return state.ImagesOfProperty;
    }

    return postApiCall(
      `${baseUrl}Document/GetPropertyImagesPresignedUrls`,
      requestForPropertyImages
    );
  }
);

export const propertyImagesSlice = createSlice({
  name: "propertyImages",
  initialState,
  reducers: {
    resetState: (state) => {
      state.ImagesOfProperty = [];
      state.error = "";
      state.loading = false;
      state.cacheKey = undefined;
    },
  },
  extraReducers: (builder) => {
    // eslint-disable-next-line
    builder.addCase(propertyImages.pending, (state) => {
      state.loading = true;
    }),
      builder.addCase(
        propertyImages.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.ImagesOfProperty = action.payload;
          state.cacheKey = "propertyImagesCache";
          console.log("rec data", state.ImagesOfProperty);
        }
      ),
      builder.addCase(propertyImages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "something went wrong";
      });
  },
});

export const { resetState: resetPropertyImagesAction } =
  propertyImagesSlice.actions;
export default propertyImagesSlice.reducer;